import { computed } from 'vue';
import { orderBy } from 'lodash';
import { useDevicesStore } from '../devices/device-store';

const getModelsForHardwareType = (type) => {
  const store = useDevicesStore();
  const types = computed(() => store.state.types);
  const models = computed(() => store.state.models);

  // check for empty list
  if (!types?.value) return []; 
  // find matching DeviceType
  const typeMatch = types?.value?.find(t => t.shortcode == type);      
  // unable to match hardware type, return empty array
  if (!typeMatch) return [];
  // return list of available hardware models for type
  return orderBy(models?.value?.filter(m => m.deviceTypeId == typeMatch.id && !m.shortcode.includes('u8')), ['name'], ['asc']);
}

export default getModelsForHardwareType;
